import { useTranslation } from 'react-i18next';
import Switch from '../../Fundamentals/Switch/Switch';
import { PACKAGE_FLAGS } from './packageConstants';
import type { PackageDraft } from './Packages.types';

interface PackageFlagTogglesProps {
    flags: PackageDraft['flags'];
    onChange: (flags: PackageDraft['flags']) => void;
    disabled?: boolean;
}

const PackageFlagToggles = ({ flags, onChange, disabled = false }: PackageFlagTogglesProps) => {
    const { t } = useTranslation();

    return (
        <>
            <h4 className="mt-24 font-16">{t('packages.flags')}</h4>
            <div className="border rounded-4">
                {PACKAGE_FLAGS.map((flag, index) => (
                    <Switch
                        key={flag.field}
                        id={flag.field}
                        className={`p-12${index > 0 ? ' border-top' : ''}`}
                        label={t(flag.labelKey) ?? ''}
                        description={t(flag.descriptionKey) ?? ''}
                        checked={flags[flag.field]}
                        disabled={disabled}
                        onChange={(checked) => onChange({ ...flags, [flag.field]: checked })}
                    />
                ))}
            </div>
        </>
    );
};

export default PackageFlagToggles;
